import type { AnchorHTMLAttributes } from 'react';
import { useOptionalSession } from '../../data/hooks.tsx';
import { useOpenRecord } from './hooks.ts';

/**
 * A link to a record. A click opens it in a window; the address (`/p/…/r/…`) still works for new
 * tabs, copied links and modified clicks.
 */
export function RecordLink({ id, onClick, ...props }: { id: string } & AnchorHTMLAttributes<HTMLAnchorElement>) {
  const session = useOptionalSession();
  const open = useOpenRecord();
  if (!session) return <span className={props.className}>{props.children}</span>;
  return (
    <a
      {...props}
      href={`/p/${session.id}/r/${id}`}
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        open(id);
      }}
    />
  );
}
